<template>
  <div class="index">
   <h3 class="buy-title">{{title}}
   </h3>
    <div class="order-container">
    </div>
  </div>
</template>

<script>

export default {
  name: "index",
  props:{
      title:String
  },
  components: {

  },
  data() {
    return {
     
    };
  },
  methods: {
 
  },
  mounted(){
    
  }
};
</script>

<style lang="less" scoped>
.index{
    padding: 32px 0;
    .title-contact{
        font-size: 16px;
        float:right;
        line-height: 30px;
    }
 
}

</style>
